import { ContentProvider } from "@/models/contentprovider";
import { ServiceProvider } from "@/models/serviceprovider";
import { ANumberGroup } from "@/models/anumbergroup";

export interface IMassAnumbersUpdateRequest {
    aNumberDtos: Array<IMassANumberUploadToProgramContent>;
}

export interface IMassANumberUploadToContentProvider {
    phoneNumbers: string[];
    note: string;
}

export interface IMassANumberUploadToProgramContent {
    phoneNumber: string;
    programContentUuid: string | null;
}
export interface IMassANumberUpload {
    massANumberUploadId?: string | null;
    contentProvider?: ContentProvider | null;
    serviceProvider?: ServiceProvider | null;
    aNumberGroup?: ANumberGroup | null;
    created?: string | null;
    updateDate?: string | null;
    note?: string | null;
    aNumbers?: any | null;
}

export class MassANumberUpload {
    public massANumberUploadId!: string | null;
    public contentProvider!: ContentProvider | null;
    public serviceProvider!: ServiceProvider | null;
    public aNumberGroup!: ANumberGroup | null;
    public created!: string | null;
    public updateDate!: string | null;
    public note!: string | null;
    public aNumbers!: any | null;

    constructor(massANumberUpload: IMassANumberUpload | any) {
        if (!massANumberUpload) {
            throw new Error(
                "Cannot construct ANumber Assignment from falsey IMassANumberUpload"
            );
        }

        this.massANumberUploadId =
            massANumberUpload.massANumberUploadId || null;
        this.contentProvider =
            massANumberUpload.contentProvider || ContentProvider.empty();
        this.serviceProvider =
            massANumberUpload.serviceProvider || ServiceProvider.empty();
        this.aNumberGroup =
            massANumberUpload.aNumberGroup || ANumberGroup.empty();
        this.created = massANumberUpload.created || null;
        this.updateDate = massANumberUpload.updateDate || null;
        this.note = massANumberUpload.note || null;
        this.aNumbers = massANumberUpload.aNumbers || [];
    }

    public static empty(): MassANumberUpload {
        return new MassANumberUpload({});
    }

    public toCreateMassANumberUploadDto(): IMassANumberUploadToContentProvider {
        return {
            phoneNumbers: this.aNumbers,
            note: "Generated by upload from date: " + new Date(),
        };
    }

    public toCreateMassAssignANumberUploadDto(
        assign: boolean,
        data: Array<any>
    ): IMassAnumbersUpdateRequest {
        const pairs: IMassANumberUploadToProgramContent[] = [];
        data.map((row: Array<any>) => {
            pairs.push({
                phoneNumber: assign ? row[0] : row,
                programContentUuid: assign ? row[1] : null,
            });
        });
        return {
            aNumberDtos: pairs,
        };
    }
}
